export const COURSE_STATUSES = 'COURSE_STATUSES';


// WEBPACK FOOTER //
// ./src/store/modules/courseStatus/mutation-types.js